import { Component, defineComponent } from './component-base.js';

class BrandsMegaMenuComponent extends Component {
  #onJumpClick = (event) => {
    const button = event.currentTarget;
    const key = button?.getAttribute('data-brand-jump');
    if (!key) return;

    const scroller = this.querySelector('[data-brands-scroller]');
    const column = scroller?.querySelector(`[data-brand-column="${key}"]`);
    if (!scroller || !column) return;

    const paddingLeft = parseFloat(getComputedStyle(scroller).paddingLeft) || 0;
    const nextLeft =
      scroller.scrollLeft +
      (column.getBoundingClientRect().left - scroller.getBoundingClientRect().left) -
      paddingLeft;

    scroller.scrollTo({
      left: Math.max(0, nextLeft),
      behavior: 'smooth',
    });
  };

  connectedCallback() {
    super.connectedCallback();

    this.querySelectorAll('[data-brand-jump]:not([disabled])').forEach((button) => {
      button.addEventListener('click', this.#onJumpClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-brand-jump]').forEach((button) => {
      button.removeEventListener('click', this.#onJumpClick);
    });
  }
}

defineComponent('brands-mega-menu-component', BrandsMegaMenuComponent);
